import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const chargingHistory: IMcAppType = {
  name: "chargingHistory_SAP",
  path: "/my-account/ev",
  description: "Origin ev charging history",
  navFlow: NavFlow.STANDARD,
  title: "Charging history",
  parent: Tab.MORE,
  conditions: {
    intent: "chargingHistory",
    customerType: CustomerType.sap,
  },
};

export const chargingHistory_KRAKEN: IMcAppType = {
  name: "chargingHistory_KRAKEN",
  path: "/my/service/ev",
  description: "Origin ev charging history",
  navFlow: NavFlow.STANDARD,
  title: "Charging history",
  parent: Tab.MORE,
  conditions: {
    intent: "chargingHistory",
    customerType: CustomerType.kraken,
  },
};
